import { Injectable, inject } from '@angular/core';
import { WIRELESS_ROUTE } from '../app.constant';
import { BreadcrumbsService } from '../core/breadcrumbs/breadcrumbs.service';
import { changeCallerIdBreadcrumbsConfig } from './change-caller-id-breadcrumbs.config';
import { AccountDetailFacadeService } from '@rogers/self-serve-common/account';
import { GlobalApiErrorTrackingService } from '../core/analytics';

@Injectable()
export class ChangeCallerIdAppConfigService {
  private readonly breadcrumbsService = inject(BreadcrumbsService);
  private readonly accountDetailFacadeService = inject(AccountDetailFacadeService);
  private readonly globalApiErrorTrackingService = inject(GlobalApiErrorTrackingService);

  constructor() {
    this.breadcrumbsService.addBreadcrumbData(changeCallerIdBreadcrumbsConfig);
    this.globalApiErrorTrackingService.addErrorHandler([
      {
        useRegex: true,
        regex: /\/caller-id/,
      },
    ]);
  }

  get fallbackRoute() {
    return `/${WIRELESS_ROUTE}`;
  }

  readonly contactUrl = '/contact';

  readonly showFairUsagePolicy = false;

  notifyChangeCallerIdSuccess(accountNumber: string, subscriptionAlias: string, firstName: string, lastName: string) {
    this.accountDetailFacadeService.updateFirstNameLastName(accountNumber, subscriptionAlias, firstName, lastName);
  }
}
